import { SET_SONG_ATTRIBUTES } from '@/store/actions/metadata/action-typs';

const initialState = Object.assign({}, {
  songTypes: {},
  compositions: {},
  contractStatus: {},
  keyTonics: [],
  keySignatures: []
});

const reducer = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case SET_SONG_ATTRIBUTES:
      return setSongAttributes(state, payload);
    default:
      return state;
  }
};

const setSongAttributes = (state, payload) => {
  const { songTypes, compositions, contractStatus, keyTonics = [], keySignatures = [] } = payload;

  return {
    ...state,
    songTypes: songTypes,
    compositions: compositions,
    contractStatus: contractStatus,
    keyTonics: keyTonics,
    keySignatures: keySignatures
  };
};

export default reducer;
